





























import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class productUnitPanel extends Vue {
    public $refs: {
    };
    columnsUnit= ["件","条","套","只","双","盒","台","袋","个","包","桶","卷","打","副"];
    
    show = false;

    defaultIndex = 0;

    created() {
    }
    mounted() {
     
        
    }

    moveHandle() {}
    onClose(){
        this.show = false;
    }
    Confirm(value){
        let newVal = this.unitname2index(value);
        this.$emit("unitConfirm",newVal);
        this.show = false;
    }
    unitname2index(name){
        switch (name) {
            case '件':
                return 1;
            case '条':
                return 2;
            case '套':
                return 3;
            case '只':
                return 4;
            case '双':
                return 5;
            case '盒':
                return 6;
            case '台':
                return 7;
            case '袋':
                return 8;
            case '个':
                return 9;
            case '包':
                return 10;
            case '桶':
                return 11;
            case '卷':
                return 12;
            case '打':
                return 13;
            case '副':
                return 14;
            default:
                return 0;
        }
    }
    unitindex2name(index){
        switch (index) {
            case 1:
                return '件';
            case 2:
                return '条';
            case 3:
                return '套';
            case 4:
                return '只';
            case 5:
                return '双';
            case 6:
                return '盒';
            case 7:
                return '台';
            case 8:
                return '袋';
            case 9:
                return '个';
            case 10:
                return '包';
            case 11:
                return '桶';
            case 12:
                return '卷';
            case 13:
                return '打';
            case 14:
                return '副';
            default:
                return 0;
        }
    }
    showFun(val){
        console.log('val',val);
        
        if(val){
            this.defaultIndex  = this.unitname2index(val)-1;
        }
        this.show = true;
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/productUnitPanel.vue